import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    RadioButton,
    RadioLabel
} from './RadioButtons.style';
import { SingleRadioButton } from './SingleRadioButton';

export interface GroupOption<T> {
    value: T,
    label: JSX.Element | string
}

interface RadioButtonStateLessPropsTypes {
    color?: 'light' | 'dark',
    className?: string;
    name: string,
    group: Array<GroupOption<string>>,
    isDisabled?: boolean,
    size?: 'small' | 'large',
    gap?: string,
    selectValue: string | null,
    onChangeCallback?: (newSelectValue: string) => void
    showPointer: boolean
}
export const RadioButtonsStateLess = observer('RadioButtonsStateLess', (props: RadioButtonStateLessPropsTypes) => {
    const { gap, className, color, name, isDisabled = false, size = 'large', group, selectValue, onChangeCallback, showPointer = true } = props;

    return (
        <>
            {group.map(({ value, label }) => {
                const itemValue: string = value;
                const labelItem: JSX.Element | string = label;
                const isChecked = itemValue === selectValue;

                return (
                    <RadioButton gap={gap} showPointer={showPointer} className={className} isDisabled={isDisabled} color={color} isActive={isChecked} key={`${itemValue}`} data-test-selected={isChecked ? true : false} data-test={`radio-button-${value}`}>
                        <SingleRadioButton
                            name={name}
                            isDisabled={isDisabled}
                            isChecked={isChecked}
                            value={itemValue}
                            onChange={onChangeCallback}
                        />
                        <RadioLabel size={size}>{labelItem}</RadioLabel>
                    </RadioButton>
                );
            })}
        </>
    );
});
